export default __webpack_public_path__ + "812449646e96d93b5f7fcb3fd7eee9fe.jpg";